import axios from '../axios'
// 搜索列表
export const getExperienceList = (data) => {
  return axios({
    url: '/con/account/listCorrectUser',
    method: 'POST',
    data
  })
}
export const updateParentCorrectCount = (data) => {
  return axios({
    url: '/con/account/updateParentCorrectCount',
    method: 'POST',
    data
  })
}
export const updateCorrectCount = (data) => {
  return axios({
    url: '/con/account/updateCorrectCount',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/experienceNote.js